import React from 'react';
import PropTypes from 'prop-types';
import { useLayout } from '../layout/context';
import Icon from '../share-block/icon';
import RichText from '../rich-text';
import LinkList from './link-list';
import BrushCaret from '../../assets/brush/brush-caret.png';
// Utils
import { consistentString } from '../../utils/content-formatting';
// Styles
import { FlexRow, FlexCol } from '../styled/flexgrid';
import {
  Wrapper,
  StyledContainer,
  Top,
  Social,
  SocialLink,
  FooterLinksContainer,
  Bottom,
  BottomInner,
  ContentWrapper,
  Text,
  FooterCallout,
  FooterCalloutText,
  FooterCalloutIdent,
  FooterCalloutSeparator,
} from './styles';

const Footer = ({
  footerText,
  shareType,
  navigationItems,
  linkedIn,
  twitter,
  facebook,
  instagram,
  tiktok,
}) => {
  const { removeFooterMargin } = useLayout();
  const replaceDateShortCode = (text) => {
    const regex = /\[date\]+/gi;
    return text.replace(regex, new Date().getFullYear());
  };

  const socialUrls = {
    instagram,
    twitter,
    facebook,
    tiktok,
    linkedIn,
  };

  return (
    <Wrapper $removeMarginTop={removeFooterMargin} data-funnelbacknoindex>
      <Top>
        <StyledContainer $noMobilePadding>
          <FlexRow>
            <FlexCol $flexCol="8">
              {navigationItems ? (
                <FooterLinksContainer aria-label="Footer Links">
                  <FlexRow>
                    {navigationItems.map((item) => (
                      <FlexCol key={`${item.id}`}>
                        <LinkList pageData={item} />
                      </FlexCol>
                    ))}
                  </FlexRow>
                </FooterLinksContainer>
              ) : null}
            </FlexCol>
            <FlexCol $flexCol="1">
              <FooterCalloutSeparator />
            </FlexCol>
            <FlexCol $flexCol="3">
              <FooterCallout aria-hidden="true">
                <FooterCalloutIdent src={BrushCaret} alt="" />
                <FooterCalloutText>Home is everything</FooterCalloutText>
              </FooterCallout>
            </FlexCol>
          </FlexRow>
        </StyledContainer>
      </Top>

      <Bottom>
        <StyledContainer $noMobilePadding>
          <BottomInner>
            <ContentWrapper>
              <Social>
                {shareType &&
                  Object.keys(socialUrls).map((platform) =>
                    socialUrls[platform] ? (
                      <SocialLink
                        key={`${platform}-social-link`}
                        href={socialUrls[platform]}
                        aria-label={`Follow Shelter on ${platform}`}
                        className="tracking-footer-social"
                        data-tracking={platform.toLowerCase()}
                        data-socialfooter={platform}
                      >
                        <Icon
                          key={`${platform}-social-icon`}
                          icon={consistentString(platform)}
                        />
                      </SocialLink>
                    ) : null
                  )}
              </Social>
              <Text>
                <RichText
                  richText={footerText}
                  textRenderer={replaceDateShortCode}
                />
              </Text>
            </ContentWrapper>
          </BottomInner>
        </StyledContainer>
      </Bottom>
    </Wrapper>
  );
};

Footer.propTypes = {
  navigationItems: PropTypes.array,
  shareType: PropTypes.array,
  twitter: PropTypes.string,
  facebook: PropTypes.string,
  linkedIn: PropTypes.string,
  instagram: PropTypes.string,
  tiktok: PropTypes.string,
  footerText: PropTypes.object,
};

export default React.memo(Footer);
